module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "120px"
    }
  }, [_vm._v("After years of being told to write down my sardonic musings, I finally took the plunge. These poems explore the various thoughts that I, and others, have had at various points in life and are easily read and accessible for all.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("When I began writing, I noticed that poetry that rhymed appeared to be a bit of an enigma these days, so I have specifically created rhyming poems that take the reader on a journey. That journey can be happy, sad, comedic, tragic, or whimsical, but it’s certainly a journey, and I hope you, yes you, enjoy reading them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0